import { lazyLoad } from 'utils/loadable';

export const AnalyticsSettings = lazyLoad(
  () => import('./index'),
  module => module.AnalyticsSettings,
);
